function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M15 2.5l.308.004C22.07 2.667 27.5 8.199 27.5 15l-.004.308C27.333 22.07 21.801 27.5 15 27.5 8.096 27.5 2.5 21.904 2.5 15S8.096 2.5 15 2.5zM15 5C9.477 5 5 9.477 5 15s4.477 10 10 10l.28-.004C20.673 24.848 25 20.43 25 15l-.004-.28C24.848 9.327 20.43 5 15 5zm1.62 6.605a1.25 1.25 0 011.767.008c.494.497.49 1.288 0 1.774L16.762 15l1.625 1.613c.494.497.49 1.288 0 1.774a1.252 1.252 0 01-1.775 0L15 16.762l-1.613 1.625a1.252 1.252 0 01-1.774 0 1.252 1.252 0 010-1.775L13.238 15l-1.625-1.613-.092-.101a1.255 1.255 0 011.867-1.673L15 13.238l1.613-1.625z"
}));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.ffebd0c9.svg";
export { ForwardRef as ReactComponent };